import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehicleModalService {

  private selectedVehicleSubject = new BehaviorSubject<any>(null);
  public selectedVehicle$ = this.selectedVehicleSubject.asObservable();

  constructor() { }

  setSelectedVehicle(vehicle: any): void {
    this.selectedVehicleSubject.next(vehicle);
  }

  getSelectedVehicle(): any | null {
    return this.selectedVehicleSubject.value;
  }

  clearSelectedVehicle(): void {
    this.selectedVehicleSubject.next(null);
  }
}
